// extracted by mini-css-extract-plugin
export default {"mainMenu":"SideNavMenu_mainMenu__sAbfy"};